import z from "zod";
import ExerciseCategoryService from "../../../../services/ExerciseCategoryService";
import { mapErrorsToFields } from "../../../../utils";

const api = new ExerciseCategoryService();
export type State = {
  errors?: {
    name?: string[];
    orderNumber?: string[];
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    name?: string;
    orderNumber?: number;
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),
  orderNumber: z.int().min(1, "Order Number is required."),
});

export async function addCategory(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",
    orderNumber: parseInt( formData.get("orderNumber")?.toString() ?? "1"),
  };
  console.log({defaultValues})
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Exercise Category.",
      };
    }
    const { name , orderNumber} = validatedFields.data;

    const result = await api.addExerciseCategory({ name , orderNumber: Number(orderNumber) });
    if (result.status == 201)
      return {
        message: "Exercise Category created successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to create exercise category.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create exercise category.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}
export async function updateCategory(
    id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",
    orderNumber: parseInt( formData.get("orderNumber")?.toString() ?? "1")
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update Exercise Category.",
      };
    }
    const { name ,orderNumber} = validatedFields.data;

    const result = await api.updateExerciseCategory(id, { id, name ,orderNumber});
    if (result.status == 204)
      return {
        message: "Exercise Category updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update exercise category.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update exercise category.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteCategory(id: number, prevState: State) {
  try {
    await api.deleteExerciseCategory(id);
    return {
      message: "Exercise category deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete exercise category.",
      success: false,
    };
  }
}
